module.exports = ".line-titles .circle {\n  display: inline-block;\n  width: 30px;\n  height: 13px; }\n  .line-titles .circle.firstData-title {\n    border: 2px solid #727cf5;\n    background-color: #dadcfc; }\n  .line-titles .circle.secondData-title {\n    margin-left: 5px;\n    border: 2px dashed #0acf97; }\n  .w-print {\n  width: 65% !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/charts/chart-line/chart-line.component.scss
// module id = ./src/app/components/tools/charts/chart-line/chart-line.component.scss
// module chunks = main